/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![NitroWheelIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWklEQVR4nO2Uz0rCQRDHvXmyqF4iCnqCuq+588dkm1mjZyqxXibqFN2DCjxrLxAVeDCK+Smki9ZvPXlwYGDZXfY785mdqVTWtrIGrA/I+v23ywewvgBJBzHsZQkgyf3/Ar8OJF9I2nXOVZfKyHM8LCl2u5QIkRyVzoi0O4/3EJvaABZfrBehYO17ii1ErJl7igysvVlcOgLQ/ZT3kCgem8giAWDthxC20+wajfaWnSUil9nsPcVWEdA4iFcgGXiW+nhPQoLpMZ89Yq1ASjKYzsr2nDvbSL9wfg/gYoEQwmaC6D27BzxFHmOTuonY49BUNwnqNBtR0aGzRe5ZQdN7zOc701mVLjKAHhQdmvwkK6gxN7fI5zw+Kj06kOU6Z2RMxkanUtacc1UkuSvfxXKTPSqcc1UguUpxpcPOIl962JlZ+yPLBZI+Iesnsrwhy7MV1J/E3eLS2lbOfgDHx4pcU/23BwAAAABJRU5ErkJggg==)
 */
export const NitroWheelIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M7 4a1 1 0 0 0 0 2h3a1 1 0 1 1 0 2H5.5a1 1 0 0 0 0 2H8a1 1 0 1 1 0 2H6a1 1 0 1 0 0 2h1.25A8 8 0 1 0 15 4H7Zm8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2.5 10a1 1 0 0 0 0-2H2a1 1 0 0 0 0 2h.5Z"
        className={colorClass}
      />
    </svg>
  );
};
